import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <div className="relative overflow-hidden bg-white">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-32 flex flex-col items-center text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-sm font-semibold px-4 py-2 rounded-full mb-8"
        >
          <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
          Finance your buyout. Switch today.
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-5xl md:text-7xl font-extrabold text-slate-900 tracking-tight mb-8 max-w-4xl leading-tight"
        >
          Break free from your carrier.{' '}
          <span className="text-blue-600">We'll finance the switch.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-xl text-slate-600 mb-12 max-w-2xl leading-relaxed"
        >
          Stuck paying off a device on Verizon, AT&T, or T-Mobile? We help you finance that buyout so you can switch to an MVNO plan for as little as $8/mo — immediately.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <Link to="/dashboard" className="btn-primary text-lg px-8 py-4">
            Get My Payoff Quote
          </Link>
          <Link to="/how-it-works" className="btn-secondary text-lg px-8 py-4">
            See How It Works
          </Link>
        </motion.div>
      </div>
    </div>
  );
}